<template>
	<TemplateAuth>
		<FormLogin />
	</TemplateAuth>
</template>
<script lang="ts">
import Vue from 'vue'

import FormLogin from '@cv/components/organisms/FormLogin.vue'
import TemplateAuth from '@cv/templates/TemplateAuth.vue'

export default Vue.extend({
	components: {
		TemplateAuth,
		FormLogin
	}
})
</script>
